import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button } from "@material-ui/core";
import { buildZendeskLink } from "src/store/adminHtml/selector";
import React from "react";
import type { User } from "src/interfaces/systemState.interface";
import { useSelector } from "react-redux";
import { selectUser } from "src/store/system/selector";
import theme from "src/theme";

const useStyles = makeStyles({
  minimalMarginBottom: {
    marginBottom: "10px",
  },
  textField: {
    marginTop: theme.spacing(1),
    width: "100%",
  },
});

interface SomethingElseDialogProps {
  cancellationReason: string;
  setCancellationReason: (reason: string) => void;
}

function SomethingElseDialog(props: SomethingElseDialogProps) {
  const classes = useStyles();

  return (
    <div style={{ marginTop: "1rem" }}>
      <Typography>
        <Box component="span" fontWeight="fontWeightMedium">
          Please tell us about your reason for cancelling.
        </Box>{" "}
        We will get in touch if we feel there's something we can do about it.
      </Typography>
      <TextField
        id="filled-basic"
        label="Describe the Reason"
        variant="filled"
        className={classes.textField}
        value={props.cancellationReason}
        onChange={(event) => {
          props.setCancellationReason(event.target.value);
        }}
      />
    </div>
  );
}

export default SomethingElseDialog;
